<template>
  <v-form class="statisticsFilter layout">
    <v-flex
      v-if="filters.includes('hotspot')"
      class="grow sm4 md4 lg4 xl4 mr-2"
    >
      <label>Адрес</label>
      <v-select
        v-model="params.hotspot_id"
        @change="send"
        :items="$store.getters.hotspotList"
        item-value="id"
        item-text="address"
        height="36"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      >
        <template v-slot:selection="{ item }">
          <div class="ellipsis text-capitalize">
            <span
              v-if="switched"
              class="square mr-1"
              :class="
                switched === 'light'
                  ? 'square-primary'
                  : $store.getters.themeDark
                  ? 'square-strong-cyan'
                  : 'square-dark-blue'
              "
            ></span>
            {{ item.address ? item.address : item.title }}
          </div>
        </template>
        <template v-slot:item="{ item }">
          <div class="ellipsis text-capitalize">
            {{ item.address ? item.address : item.title }}
          </div>
        </template>
      </v-select>
    </v-flex>
    <v-flex v-if="filters.includes('range')" class="sm4 md4 lg4 xl4 mr-2">
      <label>Период</label>
      <date-range-picker
        :range="params.range"
        :index="-1"
        :isShowError="true"
        @update="changeDate($event)"
      ></date-range-picker>
    </v-flex>
    <v-flex v-if="filters.includes('search')" class="sm2 md2 lg2 xl2 mr-2">
      <label>{{ searchLabel }}</label>
      <v-text-field
        v-model="params.search"
        @change="send"
        height="36"
        placeholder="Поиск"
        class="content-bg--1 v-text-field--noBorder subtitle-1"
        hide-details
        solo
      >
        <template #append>
          <icon-search></icon-search>
        </template>
      </v-text-field>
    </v-flex>
    <v-flex
      v-if="filters.includes('country')"
      class="sm2 md2 lg2 xl2 mr-0 mr-xl-2"
    >
      <label>Страна клиента</label>
      <v-select
        v-model="params.country"
        @change="send"
        :items="countries"
        item-value="value"
        item-text="title"
        height="36"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      >
        <template v-slot:selection="{ item }">
          <div class="ellipsis">{{ item.title }}</div>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      v-if="filters.includes('periodVisits')"
      class="sm2 md2 lg2 xl2 mr-2"
    >
      <label>Частота посещений</label>
      <v-select
        v-model="params.periodVisits"
        @change="send"
        :items="periodVisitsList"
        item-value="value"
        item-text="title"
        height="36"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      ></v-select>
    </v-flex>
    <v-flex v-if="filters.includes('typeVisits')" class="sm2 md2 lg2 xl2 mr-2">
      <label>Показывать посетителей</label>
      <v-select
        v-model="params.typeVisits"
        @change="send"
        :items="typeVisitsList"
        item-value="value"
        item-text="title"
        height="36"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      ></v-select>
    </v-flex>
    <v-flex v-if="filters.includes('cntDaysGone')" class="sm2 md2 lg2 xl2 mr-2">
      <label>Посетитель не был</label>
      <v-select
        v-model="params.cntDaysGone"
        @change="send"
        :items="cntDaysGoneList"
        item-value="value"
        item-text="title"
        height="36"
        class="content-bg--1 v-text-field--noBorder"
        hide-details
        dense
        solo
      >
        <template v-slot:selection="{ item }">
          <div class="ellipsis">{{ item.title }}</div>
        </template>
      </v-select>
    </v-flex>
  </v-form>
</template>

<script>
import DateRangePicker from "../common/DateRangePicker.vue";
import IconSearch from "../icon/IconSearch.vue";
import moment from "moment";

export default {
  name: "StatisticsFilter",

  components: {
    IconSearch,
    DateRangePicker,
  },

  props: {
    // активные фильтры
    filters: {
      type: Array,
      default: function () {
        return ["hotspot", "range"];
      },
    },
    // label для поиска
    searchLabel: {
      type: String,
      default: function () {
        return "Поиск";
      },
    },
    // параметры фильтров по умолчанию
    defaultParams: Object,
    // статус загрузки
    loading: {
      type: Boolean,
      default: false,
    },
    switched: String,
  },

  data: () => ({
    // параметры формы
    params: {},
    // список стран
    countries: [
      {
        title: "все",
        value: null,
      },
      {
        title: "Россия",
        value: "ru",
      },
      {
        title: "Зарубеж",
        value: "abroad",
      },
    ],
    // частота посещений
    periodVisitsList: [
      {
        title: "День",
        value: "day",
      },
      {
        title: "Неделя",
        value: "week",
      },
      {
        title: "Месяц",
        value: "month",
      },
      {
        title: "Квартал",
        value: "quarter",
      },
    ],
    // тип посещений
    typeVisitsList: [
      {
        title: "Редкие",
        value: "seldom",
      },
      {
        title: "Частые",
        value: "often",
      },
      {
        title: "Все",
        value: null,
      },
    ],
    // список периодов ушедших клиентов
    cntDaysGoneList: [
      {
        title: "Более 30 дней",
        value: 30,
      },
      {
        title: "Квартал",
        value: 90,
      },
    ],
    // для отображения IconClose
    isSeen: false,
  }),

  beforeMount() {
    // устанавливаем параметры по умолчанию
    this.params = this.defaultParams;
  },

  watch: {
    // обновление данных, если меняется шаблон
    defaultParams() {
      this.params = this.defaultParams;
    },
  },

  methods: {
    /**
     * Отправляет выбранный период
     */
    send() {
      this.params.hotspotName = this.$store.getters.getHotspot(
        this.params.hotspot_id
      )["hotspot_name"];
      const filterStatistics = {
        ...this.params,
        range: {
          startDate: this.params.range.startDate,
          endDate: this.params.range.endDate,
        },
      };
      this.isSeen = true;
      this.$emit("filter", filterStatistics);
    },
    // обновляем дату и отправляем данные
    changeDate(range) {
      this.params.range = range;
      if (!range.startDate) {
        this.params.range.startDate = moment().subtract(1, "month");
        this.params.range.endDate = new Date();
      }
      this.send();
      this.isSeen = false;
    },
  },
};
</script>
